////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import { isNull } from 'lodash'
///////COMPONENTS///////
import TableNested from '../../../../../components/Table/components/TableNested'

//////STYLED//////
const TelecollectDetailSaleNestedWrapper = styled.td`
	display: ${(props) => (props.isVisible ? 'table-cell' : 'none')};
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
	& > div {
		max-width: calc(100% - 200px);
		position: sticky;
		left: 100px;
		min-width: max-content;
	}
	& > div:before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -1px;
		box-shadow: 3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div:after {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		right: -1px;
		box-shadow: -3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div > div {
		min-width: max-content;
	}
`
//////STYLED//////

const TelecollectDetailSaleNested = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: '',
		isInNestedTable: true,
	}

	const currency = props.row.currency.symbol

	const columns = [
		{
			dataHook: 'itemFamilly.translationKey',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_expand_tableHeader__itemFamilly'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
			toMapObject: true,
		},
		{
			dataHook: 'itemBrand.label',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_expand_tableHeader__itemBrand'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'itemType',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_expand_tableHeader__gasType'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
		},
		{
			dataHook: 'itemCode',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_expand_tableHeader__itemCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'itemLabelToDisplay',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_expand_tableHeader__itemLabel'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'amountItemTTC',
			headerName:
				translations[
					'modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_expand_tableHeader__transactionLineAmountTTC'
				],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.amountItemTTC) ? `${props.row.amountItemTTC}${currency}` : `0${currency}`),
		},
		/*{ dataHook: 'kioskCode', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_kioskCode'], sortable: true, "isAuthorize": true },
		{ dataHook: 'store', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_store'], sortable: true, "isAuthorize": true },
		{ dataHook: 'itemFamily.translationKey', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_family'], sortable: true, "isAuthorize": true, toTranslate: true },
		{ dataHook: 'itemBrand.label', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_brand'], sortable: true, "isAuthorize": true },
		{ dataHook: 'label', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_product'], sortable: true, "isAuthorize": true },
		{ dataHook: 'standardPrice', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemPrice'], sortable: true, "isAuthorize": true, component:props => (isNumber(props.row.standardPrice)) ? PriceFormatter.PriceFormatter(props.row.standardPrice,currency) : `0${currency}`},
		{ dataHook: 'standardPriceVATRate', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_itemVAT'], sortable: true, "isAuthorize": true, component: props => (isNumber(props.row.standardPriceVATRate)) ? `${props.row.standardPriceVATRate}%` : '0%'},
		{ dataHook: 'depositPrice', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositPrice'], sortable: true, "isAuthorize": true, component:props => (isNumber(props.row.depositPrice)) ? PriceFormatter.PriceFormatter(props.row.depositPrice,currency) : `0${currency}`},
		{ dataHook: 'depositPriceVATRate', headerName: translations['page__pricesManagement__pricesCampaign_nestedHeader_depositVAT'], sortable: true, "isAuthorize": true, component:props => (isNumber(props.row.depositPriceVATRate)) ? `${props.row.depositPriceVATRate}%` : '0%'},
        */
	]

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TelecollectDetailSaleNestedWrapper colSpan={props.colspan + 1} isVisible={props.stateToggleNested}>
			<div>
				<div>{<TableNested inputColumns={columns} inputData={props.row.salesOrderLines} inputConfig={config} />}</div>
			</div>
		</TelecollectDetailSaleNestedWrapper>
	)
}

TelecollectDetailSaleNested.propTypes = {}

TelecollectDetailSaleNested.defaultPropTypes = {}

export default TelecollectDetailSaleNested
